export default class OptimizedFlowViewModel {
    constructor(data) {
        this.flowName = data.flowName;
        this.caseName = data.caseName;
    }

    get isTrialPermitted() {
        return this.caseName === 'TRIAL'
    }
}